<page-title text="Trading Competition | BitOasis" i18n-text="@@pageTitle.tradingCompetition">Trading Championship</page-title>

<site-header logo="assets/images/logo-primary.svg" class="light"></site-header>

<header class="header">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 content">
        <h1 class="text-title" i18n="@@front.tradingCompetition.header.title"><strong>$30,000</strong> Trading Championship</h1>
        <div class="p-2"></div>
        <p class="text-subtitle" i18n="@@front.tradingCompetition.header.content">Sign up with your BitOasis account email to participate. Top traders will win big cash prizes and all other traders win a guaranteed share of $10,000!</p>
        <div class="p-3"></div>
        <a [href]="isAr ? REGISTER_LINK_AR : REGISTER_LINK_EN" target="_blank" rel="noopener" class="btn btn-lg btn-primary action" i18n="@@front.tradingCompetition.header.actionButton">Sign up for competition</a>
      </div><!-- .content -->
      <div class="col-lg-6 img">
        <img src="assets/images/contests/trading-competition.png" alt="Trading Competition">
      </div><!-- .img -->
    </div><!-- .row -->
  </div><!-- .container -->
</header>

<section class="countdown section">
    <div class="wrapper">
        <div class="timer">
            <div class="time">
                <div class="label" i18n="@@front.tradingCompetition.timer.days">DAYS</div>
                <div class="content">{{timer?.days | number:'2.0'}}</div>
            </div>
            <div class="separator">
                <div class="label">&nbsp;</div>
                <div class="content">:</div>
            </div>
            <div class="time">
                <div class="label" i18n="@@front.tradingCompetition.timer.hours">HOURS</div>
                <div class="content">{{timer?.hours | number:'2.0'}}</div>
            </div>
            <div class="separator">
                <div class="label">&nbsp;</div>
                <div class="content">:</div>
            </div>
            <div class="time">
                <div class="label" i18n="@@front.tradingCompetition.timer.minutes">MINUTES</div>
                <div class="content">{{timer?.minutes | number:'2.0'}}</div>
            </div>
        </div><!-- .timer -->
        <div class="p-1"></div>
        <div class="text-lg text-center text-bold" i18n="@@front.tradingCompetition.timer.endText">before winners anounced</div>
    </div>
</section>

<section class="section section-sm container">
    <h2 class="section-title" i18n="@@front.tradingCompetition.steps.title">How to Win</h2>
  <div class="steps">
      <div class="row">
          <div class="col-lg step">
              <div class="img">
                  <img src="assets/images/contests/steps/signup.png" alt="Step 1">
              </div>
              <div class="num" i18n="@@front.tradingCompetition.steps.step1.num">Step 1</div>
              <div class="title" i18n="@@front.tradingCompetition.steps.step1.title">Sign up</div>
              <div class="text" i18n="@@front.tradingCompetition.steps.step1.text">Confirm your participation with your BitOasis registered email.</div>
          </div>
          <div class="col-1"></div>
          <div class="col-lg step">
            <div class="img">
                <img src="assets/images/contests/steps/trade.png" alt="Step 1">
            </div>
            <div class="num" i18n="@@front.tradingCompetition.steps.step2.num">Step 2</div>
            <div class="title" i18n="@@front.tradingCompetition.steps.step2.title">Trade more than ever</div>
            <div class="text" i18n="@@front.tradingCompetition.steps.step2.text">Be among the top traders on the Trading Championship Leaderboard</div>
        </div>
        <div class="col-1"></div>
        <div class="col-lg step">
            <div class="img">
                <img src="assets/images/contests/steps/win.png" alt="Step 1">
            </div>
            <div class="num" i18n="@@front.tradingCompetition.steps.step3.num">Step 3</div>
            <div class="title" i18n="@@front.tradingCompetition.steps.step3.title">Get reward</div>
            <div class="text" i18n="@@front.tradingCompetition.steps.step3.text">Top traders will win big cash prizes. All other traders win a guaranteed share of $10,000!</div>
        </div>
      </div>
  </div>
</section>

<section class="section section-sm container">
    <h2 class="section-title" i18n="@@front.tradingCompetition.prizes.title">Prize Pool</h2>
    <div class="prizes">
        <div class="wrapper row">
            <div class="col-lg">
                <div class="prize">
                    <div class="img">
                        <img src="assets/images/contests/medals/1st.png" alt="First Prize">
                    </div>
                    <div class="core">
                        <div class="key" i18n="@@front.tradingCompetition.prizes.core1">Lite #1 Trader</div>
                        <div class="value">$6,000</div>
                    </div>
                    <div class="pro">
                        <div class="key" i18n="@@front.tradingCompetition.prizes.pro1">Pro #1 Trader</div>
                        <div class="value">$4,000</div>
                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg">
                <div class="prize">
                    <div class="img">
                        <img src="assets/images/contests/medals/2nd.png" alt="Second Prize">
                    </div>
                    <div class="core">
                        <div class="key" i18n="@@front.tradingCompetition.prizes.core2">Lite #2 Trader</div>
                        <div class="value">$4,000</div>
                    </div>
                    <div class="pro">
                        <div class="key" i18n="@@front.tradingCompetition.prizes.pro2">Pro #2 Trader</div>
                        <div class="value">$2,500</div>
                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg">
                <div class="prize">
                    <div class="img">
                        <img src="assets/images/contests/medals/3rd.png" alt="Third Prize">
                    </div>
                    <div class="core">
                        <div class="key" i18n="@@front.tradingCompetition.prizes.core3">Lite #3 Trader</div>
                        <div class="value">$2,000</div>
                    </div>
                    <div class="pro">
                        <div class="key" i18n="@@front.tradingCompetition.prizes.pro3">Pro #3 Trader</div>
                        <div class="value">$1,500</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="prize-full" i18n="@@front.tradingCompetition.prizes.others">All other traders — Guaranteed Share <span class="text-primary text-bold">$10,000</span></div>
    </div>
</section>

<section class="section section-sm container">
    <h2 class="section-title" i18n="@@front.tradingCompetition.rewards.title">Rewards</h2>
    <div class="top-chart">
        <div class="tabs">
            <a href="javascript: void(0);" class="tab" [class.active]="tradersChartType === TradersChartType.Core" (click)="setTradersChartType(TradersChartType.Core)" i18n="@@front.tradingCompetition.rewards.tabs.core">Lite Traders</a>
            <a href="javascript: void(0);" class="tab" [class.active]="tradersChartType === TradersChartType.Pro" (click)="setTradersChartType(TradersChartType.Pro)" i18n="@@front.tradingCompetition.tabs.pro">Pro Traders</a>
            <a href="javascript: void(0);" class="tab" [class.active]="tradersChartType === TradersChartType.Rewards" (click)="setTradersChartType(TradersChartType.Rewards)" i18n="@@front.tradingCompetition.tabs.rewards">Rewards</a>
        </div>
        <div class="content contest-blog" [class.reward-table]="tradersChartType === TradersChartType.Rewards" [class.chart-table]="tradersChartType !== TradersChartType.Rewards">
            <div class="date" i18n="@@front.tradingCompetition.rewards.lastUpdated">Last updated: {{data?.createdAt | date:'medium'}}</div>
            <ng-container [ngSwitch]="tradersChartType">
                <table *ngSwitchCase="TradersChartType.Rewards" class="titles">
                    <tr>
                        <td i18n="@@front.tradingCompetition.rewards.date" style="width: 25%;">Date</td>
                        <td i18n="@@front.tradingCompetition.rewards.nickname">Email Address</td>
                        <td i18n="@@front.tradingCompetition.rewards.type">Type</td>
                        <td i18n="@@front.tradingCompetition.rewards.reward">Reward</td>
                    </tr>
                </table>
                <table *ngSwitchDefault="" class="titles">
                    <tr>
                        <td></td>
                        <td i18n="@@front.tradingCompetition.rewards.rank">Rank</td>
                        <td i18n="@@front.tradingCompetition.rewards.nickname">Email Address</td>
                        <td i18n="@@front.tradingCompetition.rewards.volume">Trading volume</td>
                    </tr>
                </table>
            </ng-container>
            <loading *ngIf="loading" class="full" i18n="@@front.tradingCompetition.rewards.loading">Loading top traders</loading>
            <error *ngIf="error" class="full" i18n="@@front.tradingCompetition.rewards.error">Error loading top traders</error>
            <div *ngIf="!loading && !error" class="data" [innerHTML]="data?.content"></div>
        </div>
    </div>
</section>

<section class="terms">
    <div class="container section-sm">
        <h2 class="section-title" i18n="@@front.tradingCompetition.terms.title">Terms and Conditions</h2>
        <div class="content">
            <p i18n="@@front.tradingCompetition.terms.term1">To participate in the competition, please register here using your BitOasis email ID.</p>
            <p i18n="@@front.tradingCompetition.terms.term2">Customers who use Pro will win the following bitcoin prizes for the biggest trading volume during the competition period:</p>
            <ul>
                <li i18n="@@front.tradingCompetition.terms.term2.item1">$4,000 for the trader with the biggest trading volume.</li>
                <li i18n="@@front.tradingCompetition.terms.term2.item2">$2,500 for 2nd biggest trading volume.</li>
                <li i18n="@@front.tradingCompetition.terms.term2.item3">$1,500 for 3rd biggest trading volume.</li>
            </ul>
            <p i18n="@@front.tradingCompetition.terms.term3">Customers who use Lite will win the following bitcoin prizes with the biggest trading volume during the competition period:</p>
            <ul>
                <li i18n="@@front.tradingCompetition.terms.term3.item1">$6,000 for the trader with the biggest trading trading volume.</li>
                <li i18n="@@front.tradingCompetition.terms.term3.item2">$4,000 for the trader with the 2nd biggest trading volume.</li>
                <li i18n="@@front.tradingCompetition.terms.term3.item3">$2,000 for the trader with the 3rd biggest trading volume.</li>
            </ul>
            <p i18n="@@front.tradingCompetition.terms.term4">All other traders — Guaranteed Share $10,000</p>
            <p i18n="@@front.tradingCompetition.terms.term5">BitOasis reserves the right to disqualify any participation and/or withdraw the prize for violation of any of our Terms of Service as determined in BitOasis’s sole discretion.</p>
            <p i18n="@@front.tradingCompetition.terms.term6">Competition is valid in the United Arab Emirates (UAE), Saudi Arabia (KSA), Bahrain, Kuwait, and Oman.</p>
        </div>
    </div>
</section>

<site-footer></site-footer>